import React from 'react';
import CommunityLayout from "../components/layouts/CommunityLayout";
import WefayoAIChatInterface from '../components/wefayoAI/ChatInterface';
import { usePageTitle } from '../hooks/usePageTitle';

const WefayoAIChat = () => {
    usePageTitle('Wefayo AI Chat - Wefayo');
    return (
        // <MainLayout currentPage="ai-chat" showAsideLeft={false}>
        <CommunityLayout currentPage={"ai-chat"} onCommunitiesLoaded={()=>{}} >
            <div className="flex flex-col flex-1 w-full">
                <WefayoAIChatInterface />
            </div>
        </CommunityLayout>
    );
};

export default WefayoAIChat; 